export default __webpack_public_path__ + "static/9gag-e19e50b6854e20679d381c178dc3387e.svg";